<template>
  <div class="w-full xl:max-w-209">
    <div class="flex w-full p-3 px-4 mb-8 bg-sn-primary bg-opacity-10 ">
      <div v-if="variant !== 'none'" class="flex-shrink-0 w-8 xl:w-8 p-0.5 pr-0">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M9 18a8.866 8.866 0 01-3.514-.703 9.468 9.468 0 01-2.837-1.946 9.469 9.469 0 01-1.946-2.838A8.867 8.867 0 010 9c0-1.243.234-2.414.703-3.514A9.468 9.468 0 012.649 2.65 9.468 9.468 0 015.486.703 8.866 8.866 0 019 0c1.243 0 2.414.234 3.514.703a9.469 9.469 0 012.837 1.946c.811.81 1.46 1.756 1.946 2.837.469 1.1.703 2.27.703 3.514a8.866 8.866 0 01-.703 3.514 9.47 9.47 0 01-1.946 2.837 9.47 9.47 0 01-2.838 1.946C11.415 17.766 10.244 18 9 18zm1.378-3.703v-6.46H7.622v6.46h2.756zM9 3.46c-.414 0-.766.154-1.054.46-.288.288-.432.64-.432 1.054 0 .414.144.766.432 1.054.288.288.64.432 1.054.432.414 0 .766-.144 1.054-.432.288-.288.432-.64.432-1.054 0-.414-.144-.766-.432-1.054A1.393 1.393 0 009 3.459z" fill="#051446"/></svg>
      </div>
      <div>
        <p class="pb-2 font-bold leading-tight xl:text-lg font-family-portado">
          {{ title }}
        </p>
        <p class="text-sm" v-html="message" />
      </div>
    </div>
  </div>
</template>

<script>
import Alert from '~brand-components/base/alert/alert'

export default Alert.extend()
</script>
